export enum Prevalence {
  Daily = 1,
  Weekly,
  Monthly,
  Quarterly
}
